import Nullstack from 'nullstack';
export default function IconZoomIn({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zoom-in",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "10",
    cy: "10",
    r: "7"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "10",
    x2: "13",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "7",
    x2: "10",
    y2: "13"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "21",
    x2: "15",
    y2: "15"
  }), " ");
}